import { render, staticRenderFns } from "./EvaluationEvidencesRequested.vue?vue&type=template&id=5bba6abf&scoped=true&"
import script from "./EvaluationEvidencesRequested.vue?vue&type=script&lang=js&"
export * from "./EvaluationEvidencesRequested.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationEvidencesRequested.vue?vue&type=style&index=0&id=5bba6abf&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bba6abf",
  null
  
)

export default component.exports